(function () {
function initBellezaLuxury() {
  var root = document.querySelector('[data-belleza-luxury]');
  if (!root) return;

  var modal = document.querySelector('[data-blz-quiz]');
  if (!modal || modal.dataset.blzInitialized === 'true') return;
  modal.dataset.blzInitialized = 'true';
  var openers = document.querySelectorAll('[data-blz-open-quiz]');
  var closer = modal && modal.querySelector('[data-blz-close-quiz]');

  function openQuiz() {
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
  }

  function closeQuiz() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('overflow-hidden');
  }

  openers.forEach(function (button) { button.addEventListener('click', openQuiz); });
  if (closer) closer.addEventListener('click', closeQuiz);
  if (modal) modal.addEventListener('click', function (event) { if (event.target === modal) closeQuiz(); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeQuiz(); });

  var filters = document.querySelectorAll('[data-blz-filter]');
  var products = document.querySelectorAll('[data-blz-product]');
  var styleShop = document.querySelector('[data-blz-style-shop]');
  var styleLabels = {
    natural: (styleShop && styleShop.dataset.labelNatural) || 'Natural',
    soft: (styleShop && styleShop.dataset.labelSoft) || 'Soft Glam',
    glam: (styleShop && styleShop.dataset.labelGlam) || 'Glam',
    siren: (styleShop && styleShop.dataset.labelSiren) || 'Siren',
    preglued: (styleShop && styleShop.dataset.labelPreglued) || 'Előre ragasztózott'
  };

  function filterProducts(tag, shouldScroll) {
    filters.forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.blzFilter === tag);
    });
    products.forEach(function (card) {
      var tags = (card.dataset.blzProduct || '').split(' ');
      card.classList.toggle('is-hidden', tag !== 'all' && tags.indexOf(tag) === -1);
    });
    if (shouldScroll) {
      var productGrid = document.querySelector('[data-blz-product-grid]');
      if (productGrid) productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  filters.forEach(function (button) {
    button.addEventListener('click', function () { filterProducts(button.dataset.blzFilter, true); });
  });

  document.querySelectorAll('[data-blz-mood]').forEach(function (button) {
    button.addEventListener('click', function () { filterProducts(button.dataset.blzMood, true); });
  });

  var questions = [
    { title: 'Milyen hatást szeretnél?', options: [
      ['natural', styleLabels.natural, 'Finom és mindennapi'],
      ['soft', styleLabels.soft, 'Elegáns épített hatás'],
      ['glam', styleLabels.glam, 'Dús és látványos']
    ]},
    { title: 'Milyen formát szeretsz?', options: [
      ['round', 'Nyitott', 'Középen hangsúlyos'],
      ['siren', 'Nyújtott', 'Cicás és megemelt'],
      ['either', 'Rád bízom', 'A legjobb párosítást kérem']
    ]},
    { title: 'Mi a legfontosabb?', options: [
      ['preglued', 'Egyszerűség', 'Gyors, ragasztó nélküli felhelyezés'],
      ['reusable', 'Újrahasználhatóság', 'Hosszú távú prémium viselet'],
      ['either', 'A hatás', 'A forma legyen tökéletes']
    ]}
  ];

  var step = 0;
  var answers = [];
  var questionArea = modal.querySelector('[data-blz-questions]');
  var stepLabel = modal.querySelector('[data-blz-step]');
  var questionTitle = modal.querySelector('[data-blz-question-title]');
  var optionsArea = modal.querySelector('[data-blz-options]');
  var progress = modal.querySelector('[data-blz-progress]');
  var next = modal.querySelector('[data-blz-next]');
  var back = modal.querySelector('[data-blz-back]');
  var result = modal.querySelector('[data-blz-result]');
  var resultTitle = modal.querySelector('[data-blz-result-title]');
  var resultText = modal.querySelector('[data-blz-result-text]');
  var resultButton = modal.querySelector('[data-blz-result-button]');

  function renderQuestion() {
    var current = questions[step];
    stepLabel.textContent = (step + 1) + ' / 3. KÉRDÉS';
    questionTitle.textContent = current.title;
    progress.style.width = ((step + 1) * 33.333) + '%';
    optionsArea.innerHTML = '';
    current.options.forEach(function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'blz-option' + (answers[step] === option[0] ? ' is-active' : '');
      button.innerHTML = '<b>' + option[1] + '</b><small>' + option[2] + '</small>';
      button.addEventListener('click', function () { answers[step] = option[0]; renderQuestion(); });
      optionsArea.appendChild(button);
    });
    next.disabled = !answers[step];
    back.style.visibility = step ? 'visible' : 'hidden';
  }

  back.addEventListener('click', function () { if (step) { step -= 1; renderQuestion(); } });
  next.addEventListener('click', function () {
    if (step < 2) { step += 1; renderQuestion(); return; }
    var chosen = answers[2] === 'preglued' ? 'preglued' : (answers[1] === 'siren' ? 'siren' : answers[0]);
    var names = { natural: styleLabels.natural, soft: styleLabels.soft, glam: styleLabels.glam, siren: styleLabels.siren, preglued: styleLabels.preglued };
    resultTitle.textContent = names[chosen];
    resultText.textContent = chosen === 'preglued'
      ? 'Az előre ragasztózott One Press pillák adják neked a leggyorsabb, legkönnyebb és mégis luxus hatású megoldást.'
      : 'Ez a stílus emeli ki legszebben azt a hatást, amelyet a válaszaid alapján keresel.';
    resultButton.dataset.resultFilter = chosen;
    questionArea.hidden = true;
    result.classList.add('is-visible');
  });

  resultButton.addEventListener('click', function () {
    closeQuiz();
    filterProducts(resultButton.dataset.resultFilter, true);
  });

  renderQuestion();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBellezaLuxury);
} else {
  initBellezaLuxury();
}
document.addEventListener('shopify:section:load', initBellezaLuxury);
})();
